import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textStylesFn = /* @__PURE__ */ createRecipe('text-styles', {
  "color": "neutral"
}, [])

const textStylesVariantMap = {
  "color": [
    "neutral",
    "primary"
  ]
}

const textStylesVariantKeys = Object.keys(textStylesVariantMap)

export const textStyles = /* @__PURE__ */ Object.assign(memo(textStylesFn.recipeFn), {
  __recipe__: true,
  __name__: 'textStyles',
  __getCompoundVariantCss__: textStylesFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textStylesVariantKeys,
  variantMap: textStylesVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textStylesVariantKeys)
  },
  getVariantProps: textStylesFn.getVariantProps,
})